import { call, fork, put, takeEvery } from "typed-redux-saga";
import { getAppServerClient } from "@advosys/component-app-server-client-js";
import { actions, MatterLedgerEntriesActionTypes } from "./matter-ledger-entries-store";
function* getMatterLedgerEntries(action) {
    const apiResult = yield* call(getAppServerClient().finance.preparedInvoiceV2.getMatterLedgerEntriesAsync, action.payload.preparedInvoiceId);
    if (apiResult.ok) {
        yield* put(actions.getMatterLedgerEntriesSuccess(apiResult.data));
    }
    else {
        yield* put(actions.getMatterLedgerEntriesFail(apiResult.error));
    }
}
function* watchGetMatterLedgerEntriesRequest() {
    yield* takeEvery(MatterLedgerEntriesActionTypes.GetMatterLedgerEntriesRequest, getMatterLedgerEntries);
}
export const matterLedgerEntriesSagaInit = () => [fork(watchGetMatterLedgerEntriesRequest)];
